import { Service } from '@roc/client-portal-shared/services';

const BASE = '/api/v1/utility/public/survey';

export class SurveyService extends Service {
  getSurveyContext(token: string) {
    return this.get(`${BASE}/${token}`);
  }

  submitSurvey(token: string, score: number, comment: string) {
    return this.post(`${BASE}/${token}/submit`, { score, comment });
  }

  unsubscribe(token: string) {
    return this.post(`${BASE}/${token}/unsubscribe`, {});
  }
}
